var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [!_vm.isRcIframe && _vm.showHeader ? _c('headerCc') : _vm._e(), _c('el-main', {
    staticClass: "scrollbar",
    class: {
      'iframeMain': _vm.isRcIframe,
      'sourceNew': _vm.isSourceNew,
      'activateMain': _vm.isActivate
    },
    attrs: {
      "id": "main-box"
    }
  }, [_vm.menuArr && !_vm.isRcIframe && !_vm.isActivate ? _c('menuTab', {
    attrs: {
      "menuArr": _vm.menuArr
    }
  }) : _vm._e(), _c('div', {
    staticClass: "content-box"
  }, [_vm.isRoute && !_vm.isRcIframe ? _c('RouterTop', {
    staticClass: "topMenu"
  }) : _vm._e(), _c('router-view', {
    key: _vm.dataMark
  })], 1)], 1), _vm.noticeWrap ? _c(_vm.noticeWrap, {
    tag: "component",
    attrs: {
      "dialogVisible": _vm.visible.notice,
      "msg": _vm.noticeMsg
    },
    on: {
      "update:dialogVisible": function ($event) {
        return _vm.$set(_vm.visible, "notice", $event);
      },
      "update:dialog-visible": function ($event) {
        return _vm.$set(_vm.visible, "notice", $event);
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }